// @ts-nocheck
import styled from 'styled-components';
import type { StatelessFunctionalComponent } from 'react';
import { getTheme } from 'settings/theme/index';
import { TABLET_SMALL_WIDTH } from 'commons/constants';

const {
  palette: { neutral },
  noodera: { fontTypes, spacing },
} = getTheme();
export const UniversityInfo: StatelessFunctionalComponent<any> = styled.div`
  ${fontTypes.font4Article};
  color: ${neutral.hundred};
`;
export const Container: StatelessFunctionalComponent<any> = styled.div`
  width: 100%;
  max-width: 375px;
  flex: 50%;
  margin-bottom: ${spacing.x3};
  @media only screen and (min-width: ${TABLET_SMALL_WIDTH}px) {
    max-width: 464px;
    margin-bottom: 0;
    margin-right: ${spacing.x3};
  }
`;
export const LogoContainer: StatelessFunctionalComponent<any> = styled.div`
  max-width: 327.5px;
  height: auto;
  margin-bottom: ${spacing.x3};
  img {
    max-width: 100%;
    max-height: ${spacing.x2};
    @media only screen and (max-width: ${TABLET_SMALL_WIDTH}px) {
      max-height: ${spacing.x1};
    }
  }
`;
export const CampusContainer: StatelessFunctionalComponent<any> = styled.div`
  flex: 50%;
  width: 100%;

  img {
    width: 100%;
    height: 240px;
    object-fit: cover;
    border-radius: 8px;
  }
  @media only screen and (min-width: ${TABLET_SMALL_WIDTH}px) {
    img {
      max-height: 320px;
    }
  }
`;
export const Wrapper: StatelessFunctionalComponent<any> = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: ${spacing.x5};
  @media only screen and (min-width: ${TABLET_SMALL_WIDTH}px) {
    padding: ${spacing.x5} 0;
    flex-direction: row;
  }
`;
